import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from "../../../constant";
import { REPLACE_AIR } from "../../../replace_str_constant";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import { RiUserFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useCheckLogin from "../../../hook/useCheckLogin";
import { CloseMenu, notice } from "../../../redux/action/action";
import {
  clearGameLink,
  startGameLoading,
  storeGameConfig,
} from "../../../redux/action/game/gameAction";
import useDeviceType from "../../../hook/useDeviceType";
import { getRankingList } from "../../../api/getApi";
import { formatNumber } from "../../../utils/formatNumber";
import useCurrencySymbol from "../../../hook/useCurrencySymbol";
import LeaderBoardWrapper from "../LeaderBoard/LeaderBoardWrapper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ImSpinner6 } from "react-icons/im";
import RankingNumberCount from "./RankingNumberCount";
import useGames from "../../../pages/Game/useGames";

const TopGameBoard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.200");

  const symbol = useCurrencySymbol();

  const splideRef = useRef();

  const [rankingList, setRankingList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const { handlePlayGame } = useGames();

  const handleEnterGame = useCallback(
    (gameItem) => {
      const { platform, game_name_en, game_uid } = gameItem || {};

      handlePlayGame({
        gameName: game_name_en,
        gamePlatform: platform,
        gameUid: game_uid,
      });
    },
    [handlePlayGame],
  );

  // profit_ranking_status 由後端注入 window、可能晚於掛載才就位、型別也可能是字串;
  // 依賴它 + 用 == 判斷 + ref 只 call 一次
  const rankingFetchedRef = useRef(false);
  useEffect(() => {
    if (window?.profit_ranking_status == 1 && !rankingFetchedRef.current) {
      rankingFetchedRef.current = true;
      getRankingList()
        .then((data) => {
          const result = data?.data;
          const filter_empty_game_code = result?.filter(
            (item) => item?.game_code || item?.game_uid,
          );
          setRankingList(filter_empty_game_code);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [window?.profit_ranking_status]);
  return (
    <>
      <Flex
        w="100%"
        justifyContent={"space-between"}
        mb={{
          base: "5px",
          md: "0px",
        }}
        alignItems={"flex-end"}
      >
        <Text
          fontSize="xl"
          fontWeight={700}
          sx={{
            color: "#000", //預設黑色
            "@media screen and (max-width: 48em)": {
              background:
                "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(246,163,254,1) 0%, rgba(240,143,255,1) 50%, rgba(241,34,255,1) 75%, rgba(241,34,255,1) 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0px 0px 3px rgba(255, 215, 0, 0.3)",
            },
          }}
        >
          {/* {i18n("TOP GAMES")} */}
          {i18n("BETTING PAYOUT")}
        </Text>
        {/* <Text color="brand.500" fontSize="sm">
          more
        </Text> */}
      </Flex>
      {isLoading ? (
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          h="90px"
          bgColor="rgba(0,0,0,.6)"
        >
          <Icon
            as={ImSpinner6}
            fontSize={"30px"}
            className="animate-spin"
            color="yellow.500"
          />
        </Flex>
      ) : (
        <>
          {/* 在 md 以上使用垂直列表 */}
          <Box
            display={{ base: "none", md: "block" }}
            maxH="250px" // 設置最大高度，超出後可滾動
            overflowY="auto" // 啟用垂直滾動
            className="no-scrollbar" // 隱藏滾動條但保持功能
            pr="10px" // 為滾動條預留空間
          >
            <Flex
              direction="column"
              gap={{
                base: "10px",
                md: "0px",
              }}
            >
              {rankingList?.map((item, index) => {
                const { platform, game_code, profit } = item;
                return (
                  <Box
                    key={index}
                    //bg={boxBg}
                    display={"flex"}
                    h="65px"
                    alignItems={"center"}
                    gap="10px"
                    w="full"
                    cursor="pointer"
                    borderBottom="1px solid"
                    borderBottomColor={borderColor}
                    _last={{ borderBottom: "none" }} // 最後一個元素不要邊框
                    _hover={{
                      // 添加 hover 效果
                      transform: "translateX(5px)",
                      transition: "all 0.2s",
                    }}
                    onClick={() => handleEnterGame(item)}
                  >
                    <Box
                      alignItems={"center"}
                      display="flex"
                      gap="5px"
                      overflow={"hidden"}
                      justifyContent={"space-between"}
                      w="100%"
                    >
                      <Flex gap="10px" alignItems={"center"}>
                        <LazyLoadImage
                          className={
                            "min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] rounded-full"
                          }
                          src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/${
                            i18next.language
                          }/${platform}/${REPLACE_AIR(game_code)}.webp`}
                          onError={(e) => {
                            const img = e.target;
                            const currentSrc = img.src;

                            if (
                              currentSrc.endsWith(
                                `${i18next.language}/${platform}/${REPLACE_AIR(
                                  game_code,
                                )}.gif`,
                              )
                            ) {
                              img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/${
                                i18next.language
                              }/${platform}/${REPLACE_AIR(game_code)}.webp`;
                            } else if (
                              currentSrc.endsWith(
                                `${i18next.language}/${platform}/${REPLACE_AIR(
                                  game_code,
                                )}.webp`,
                              )
                            ) {
                              img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                                game_code,
                              )}.gif`;
                            } else if (
                              currentSrc.endsWith(
                                `en/${platform}/${REPLACE_AIR(game_code)}.gif`,
                              )
                            ) {
                              img.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                                game_code,
                              )}.webp`;
                            } else {
                              img.onerror = null;
                            }
                          }}
                        />
                        <Text
                          className="text-overflow"
                          fontSize="16px"
                          color="#582D0C"
                          fontWeight={700}
                        >
                          {item?.[`game_name_en`] || "-"}
                        </Text>
                      </Flex>
                      <Flex
                        fontSize="24px"
                        color="#fff"
                        alignItems={"center"}
                        gap="5px"
                        fontWeight={600}
                      >
                        {/* <Icon as={RiUserFill} /> */}
                        <Text as="span" color="v3-second-brand.500">
                          {symbol}
                        </Text>
                        <Text>
                          <RankingNumberCount value={profit} notFixed />
                        </Text>
                      </Flex>
                    </Box>
                  </Box>
                );
              })}
            </Flex>
          </Box>

          {/* 在 md 以下使用原有的水平輪播 */}
          <Box display={{ base: "block", md: "none" }}>
            <Splide
              ref={splideRef}
              options={{
                pagination: false,
                arrows: false,
                drag: "free",
                // perPage: 5,
                // perMove: 1,
                gap: "5px",
                lazyLoad: "nearby",
                fixedWidth: "120px",
                dragMinThreshold: {
                  mouse: 0,
                  touch: 10,
                },
                breakpoints: {
                  mediaQuery: "min",
                  640: {
                    fixedHeight: "90px",
                    height: "365px",
                  },
                  5000: {
                    fixedHeight: "70px",
                    height: "auto",
                  },
                },
              }}
            >
              {rankingList?.map((item, index) => {
                const { platform, game_code, profit } = item;
                return (
                  <SplideSlide>
                    <Box
                      //bg={boxBg}
                      // bgGradient="linear(to-b, #fed37f, #ffa92e)"
                      bgImage={`url(${COMMON_WEB_PATH}/911TW/bettingBG.svg)`}
                      bgPosition="center"
                      bgRepeat="no-repeat"
                      bgSize="100% 100%"
                      borderRadius={"common"}
                      display={"flex"}
                      h={{
                        base: "90px",
                      }}
                      px="10px"
                      alignItems={"center"}
                      justifyContent={"center"}
                      gap="10px"
                      cursor={"pointer"}
                      onClick={() => handleEnterGame(item)}
                    >
                      <Box
                        alignItems={"center"}
                        display="flex"
                        flexDirection={"column"}
                        gap="0px"
                        overflow={"hidden"}
                      >
                        <Flex>
                          <Box
                            //bg="brand.500"
                            bgImage={`url(${COMMON_WEB_PATH}/911TW/rankingNumberBG.svg)`}
                            bgPosition="center"
                            bgRepeat="no-repeat"
                            bgSize="100% 100%"
                            borderRadius={"full"}
                            minW="22px"
                            minH="20px"
                            display="flex"
                            alignItems={"center"}
                            justifyContent={"center"}
                            color="#fff"
                          >
                            <Text fontSize="10pt">{index + 1}</Text>
                          </Box>
                          <LazyLoadImage
                            className={
                              "min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] rounded-full"
                            }
                            src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/${
                              i18next.language
                            }/${platform}/${REPLACE_AIR(game_code)}.webp`}
                            onError={(e) => {
                              // 如果當前語言版本的圖片載入失敗，載入英文版
                              e.target.src = `${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                                game_code,
                              )}.webp`;
                            }}
                          />
                        </Flex>
                        <Flex
                          flexDirection={"column"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Text
                            className="text-overflow"
                            fontSize="10pt"
                            fontWeight={700}
                            color="#fff"
                            textAlign={"center"}
                            w="110px"
                          >
                            {item?.[`game_name_en`] || "-"}
                          </Text>
                          <Flex
                            fontSize="10pt"
                            color="#fff"
                            justifyContent={"center"}
                            alignItems={"center"}
                            gap="2.5px"
                            pl="10px"
                            w="90px"
                            position={"relative"}
                            borderRadius={"20px"}
                            bgColor={"#452E5F"}
                          >
                            {/* <Icon color="#fff" as={RiUserFill} /> */}
                            <Image
                              src={`${COMMON_WEB_PATH}/911TW/dollarRANK.webp`}
                              w={"20px"}
                              h={"20px"}
                              position={"absolute"}
                              left="0"
                            />
                            {/* <Text as="span" color="brand.700">
                          {symbol}
                        </Text> */}
                            <Text
                              className="text-overflow"
                              color="#fff"
                              maxW="100%"
                              isTruncated
                            >
                              <RankingNumberCount value={profit} notFixed />
                            </Text>
                          </Flex>
                        </Flex>
                      </Box>
                    </Box>
                  </SplideSlide>
                );
              })}
            </Splide>
          </Box>
        </>
      )}
    </>
  );
};

export default TopGameBoard;
